/** HTTP method as a neutral mono tag — the method word itself is the signal, no colour coding. */
export function MethodBadge({ method }: { method: string }) {
  return (
    <span className="inline-block min-w-[3.25rem] rounded border border-line-strong px-1.5 py-px text-center font-mono text-[11px] font-medium leading-4 text-text-2">
      {method}
    </span>
  )
}
